<template>
  <page :load="doInit">
    <v-layout row wrap>
      <v-flex lg3 xs12 class="mavContainer">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="doExport">
                <v-icon>mdi-file-export</v-icon>
              </v-btn>
              <span>Export Roles</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="initAddRole">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <span>Add Role</span>
            </v-tooltip>
          </v-toolbar>
          <v-container fluid class="pa-0">
            <v-flex xs12>
              <v-text-field label="Search" v-model="search" single-line full-width hide-details></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-divider></v-divider>
            </v-flex>
          </v-container>
          <v-list>
            <template v-if="totalRoles > 0">
              <template v-for="(role) in filteredRoles">
                <v-list-tile v-bind:key="role.value" @click="selectRole(role.value)" @contextmenu="renderContext($event, role.value)">
                  <v-list-tile-content>
                    <v-list-tile-title>{{role.label}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </template>
            <template v-else>
              <v-card-text>
                There is no Role setup
              </v-card-text>
            </template>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex lg9 xs12 class="mavContainer">
        <!-- Use card__text so it aligns with the privilege cols -->
        <div class="mb-3">
          <v-layout row class="card__text mb-4">
            <v-btn @click="expandAll" small flat>
              Expand All
              <v-icon right>mdi-arrow-expand-vertical</v-icon>
            </v-btn>
            <v-btn @click="collapseAll" small flat>
              Collapse All
              <v-icon right>mdi-arrow-collapse-vertical</v-icon>
            </v-btn>
          </v-layout>
          <v-layout row class="card__text" v-if="selectedRoles.length > 0">
            <v-flex xs4>
            </v-flex>
            <v-flex xs2 v-for="role in selectedRoles" :key="role.value">
              <div class="roleHeaderDiv">
                <v-chip color="primary" text-color="white">
                  {{role.label}}
                </v-chip>
                <div v-if="selectedRolesPrivileges[role.value].loading">
                  <v-progress-linear :indeterminate="true"></v-progress-linear>
                </div>
                <div v-else>
                  <v-divider></v-divider>
                  <div class="roleHeaderAction">
                    <v-tooltip bottom v-if="selectedRolesPrivileges[role.value].edit">
                      <v-icon color="teal" slot="activator" @click="doSaveRolePrivilege(role.value)">mdi-content-save</v-icon>
                      <span>Save</span>
                    </v-tooltip>
                    <v-tooltip bottom v-else>
                      <v-icon color="blue" slot="activator" @click="initEditRolePrivilege(role.value)">mdi-pencil</v-icon>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-icon color="red" slot="activator" @click="unselectRole(role.value)">mdi-close-circle-outline</v-icon>
                      <span>Close</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row class="card__text" align-center justify-center v-else>
            <v-icon>mdi-arrow-left-bold-hexagon-outline</v-icon>
            {{labels.selectRole}}
          </v-layout>
        </div>
        <!-- note that we only support 3 levels here (incl base level) -->
        <v-expansion-panel expand v-model="panel">
          <v-expansion-panel-content v-for="(grp, i) in getGroupsByLvl(0)" :key="i">
            <div slot="header" class="subheading">{{grp.description}}</div>
            <v-card>
              <!-- <v-layout row class="pt-2 pb-4">
                <v-flex xs4>
                </v-flex>
                <v-flex d-flex align-center justify-center xs2 v-for="role in selectedRoles" :key="role.value">
                  <div v-if="selectedRolesPrivileges[role.value].edit" class="checkAllDiv">
                    <v-tooltip bottom>
                      <v-icon color="purple" slot="activator" @click="initSelectAllRolePrivilege(grp.id, role.value)">mdi-checkbox-multiple-marked-outline</v-icon>
                      <span>Select all</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-icon color="green" slot="activator" @click="initUnselectAllRolePrivilege(grp.id, role.value)">mdi-checkbox-multiple-blank-outline</v-icon>
                      <span>Unselect all</span>
                    </v-tooltip>
                  </div>
                </v-flex>
              </v-layout> -->
              <v-card-text>
                <!-- Privileges without subgroup -->
                <div v-for="privilege in getPrivilegeByGrp(grp.id)" :key="privilege.id">
                  <v-layout row class="privilegeRow pt-3 pb-2">
                    <v-flex xs4 d-flex align-center>
                      <div class="privilegeLbl">{{privilege.description}}</div>
                      <v-tooltip top v-if="privilege.additionalInfo !== null">
                        <v-icon color="blue" slot="activator" class="pl-1" small>mdi-information</v-icon>
                        <span>{{privilege.additionalInfo}}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex d-flex align-center justify-center xs2 v-for="role in selectedRoles" :key="role.value">
                      <template v-if="selectedRolesPrivileges[role.value].edit">
                        <v-checkbox v-model="selectedRolesPrivileges[role.value].data" :value="privilege.id" hide-details class="editablePriv"></v-checkbox>
                      </template>
                      <template v-else>
                        <template v-if="selectedRolesPrivileges[role.value].data.includes(privilege.id)">
                          <v-icon color="green">mdi-check</v-icon>
                        </template>
                        <template v-else>
                          <v-icon color="red">mdi-close</v-icon>
                        </template>
                      </template>
                    </v-flex>
                  </v-layout>
                </div>
                <!-- Privileges with subgroup -->
                <div v-for="subGrp in getGroupsByLvl(grp.id)" :key="subGrp.id">
                  <v-subheader>{{subGrp.description}}</v-subheader>
                  <v-divider></v-divider>
                  <div v-for="privilege in getPrivilegeByGrp(subGrp.id)" :key="privilege.id">
                    <v-layout row class="privilegeRow pt-3 pb-2">
                      <v-flex xs4 d-flex align-center>
                        <div class="privilegeLbl">{{privilege.description}}</div>
                        <v-tooltip top v-if="privilege.additionalInfo !== null">
                          <v-icon color="blue" slot="activator" class="pl-1" small>mdi-information</v-icon>
                          <span>{{privilege.additionalInfo}}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex d-flex align-center justify-center xs2 v-for="role in selectedRoles" :key="role.value">
                        <template v-if="selectedRolesPrivileges[role.value].edit">
                          <v-checkbox v-model="selectedRolesPrivileges[role.value].data" :value="privilege.id" hide-details class="editablePriv"></v-checkbox>
                        </template>
                        <template v-else>
                          <template v-if="selectedRolesPrivileges[role.value].data.includes(privilege.id)">
                            <v-icon color="green">mdi-check</v-icon>
                          </template>
                          <template v-else>
                            <v-icon color="red">mdi-close</v-icon>
                          </template>
                        </template>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="showCreateDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline" v-if="!roleForm.id">Create Role</span>
          <span class="headline" v-else-if="!roleForm.clone">Update Role</span>
          <span class="headline" v-else>Clone Role</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="mavContainer">
              <message :messages="messages"></message>
            </v-flex>
            <v-flex xs12 class="mavContainer">
              <v-text-field :disabled="submitting" v-model="roleForm.description" :label="labels.roleDesc" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.roleDesc" v-validate="'required|name|max:255'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="showCreateDialog = false" :loading="submitting">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doDialogAction" :loading="submitting">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="showDeleteDialog" @ok="doDeleteRole">
      Are you sure you want to delete "{{contextSelected.label}}"?
    </confirm>
    <v-menu offset-y v-model="roleContext.show" absolute :position-x="roleContext.xAxis" :position-y="roleContext.yAxis" transition="no-transition" :min-width="180">
      <v-list>
        <v-list-tile @click="initUpdateRole">
          <v-list-tile-action>
            <v-icon>mdi-rename-box</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Rename</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="initCloneRole">
          <v-list-tile-action>
            <v-icon>mdi-content-copy</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Clone</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="initDeleteRole">
          <v-list-tile-action>
            <v-icon>mdi-delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Delete</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      roles: [],
      menu: [],
      search: '',
      privileges: [],
      privilegeGrps: [],
      selectedRoles: [],
      selectedRolesPrivileges: {},
      showCreateDialog: false,
      showDeleteDialog: false,
      labels: {
        selectRole: 'Select Role from the list to add to comparison table',
        roleDesc: 'Role Name*'
      },
      roleForm: {
        id: undefined,
        description: undefined,
        clone: false
      },
      submitting: false,
      roleContext: {
        show: false,
        xAxis: 0,
        yAxis: 0,
        selectedId: undefined
      },
      panel: []
    }
  },
  computed: {
    totalRoles() {
      if (this.filteredRoles) {
        return this.filteredRoles.length
      } else {
        return 0
      }
    },
    filteredRoles() {
      if (this.search && this.search !== '') {
        const result = this.roles.filter(role => {
          return role.label.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        })
        return result
      } else {
        return this.roles
      }
    },
    contextSelected() {
      const selectedRole = this.roles.filter(role => role.value === this.roleContext.selectedId)
      if (selectedRole && selectedRole.length > 0) {
        return selectedRole[0]
      } else {
        return {}
      }
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.adminUser.menu.roles
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.roles = data.data.roles
          this.privileges = data.data.privileges
          this.privilegeGrps = data.data.privilegeGrps
          this.menu = extractMenu(data._links)
        }
      } catch (err) {
        throw err
      }
    },
    getGroupsByLvl(parentId) {
      if (this.privilegeGrps && this.privilegeGrps.length > 0) {
        const result = this.privilegeGrps.filter(grp => grp.parentId === parentId)
        result.sort((a, b) => parseInt(a.seq) - parseInt(b.seq))
        return result
      }
      return []
    },
    getPrivilegeByGrp(grp) {
      if (this.privileges && this.privileges.length > 0) {
        const result = this.privileges.filter(privilege => privilege.grp === grp)
        result.sort((a, b) => parseInt(a.seq) - parseInt(b.seq))
        return result
      }
      return []
    },
    getPrivilegeByGrpDeep(grpId, result) {
      // Recursive method to get all privileges within a grp (including priv of subgrp)
      result.push(...this.getPrivilegeByGrp(grpId))
      const grps = this.getGroupsByLvl(grpId)
      if (grps && grps.length > 0) {
        for (var i = 0; i < grps.length; i++) {
          this.getPrivilegeByGrpDeep(grps[i].id, result)
        }
      }
      return result
    },
    async doExport() {
      const apiURI = this.menu.exportRoles
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.get(apiURI)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    initAddRole() {
      this.roleForm.id = undefined
      this.roleForm.description = ''
      this.roleForm.clone = false
      this.showCreateDialog = true
    },
    initUpdateRole() {
      const selectedRole = this.contextSelected
      if (selectedRole && selectedRole.value) {
        this.roleForm.id = selectedRole.value
        this.roleForm.description = selectedRole.label
        this.roleForm.clone = false
        this.showCreateDialog = true
      } else {
        // If cannot find the selectedRole (for wadeva reason), just init a addRole
        this.initAddRole()
      }
    },
    initCloneRole() {
      const selectedRole = this.contextSelected
      if (selectedRole && selectedRole.value) {
        this.roleForm.id = selectedRole.value
        this.roleForm.description = selectedRole.label
        this.roleForm.clone = true
        this.showCreateDialog = true
      }
    },
    initDeleteRole() {
      this.showDeleteDialog = true
    },
    initEditRolePrivilege(id) {
      if (this.selectedRolesPrivileges[id]) {
        this.selectedRolesPrivileges[id].edit = true
      }
    },
    initSelectAllRolePrivilege(grpId, roleId) {
      // Check to make sure both id exist
      const selectedGrp = this.privilegeGrps.filter(grp => grp.id === grpId)
      if (selectedGrp && selectedGrp.length > 0 && this.selectedRolesPrivileges[roleId]) {
        const relevantPriv = this.getPrivilegeByGrpDeep(grpId, [])
        if (relevantPriv && relevantPriv.length > 0) {
          relevantPriv.map(priv => {
            if (!this.selectedRolesPrivileges[roleId].data.includes(priv.id)) {
              this.selectedRolesPrivileges[roleId].data.push(priv.id)
            }
          })
        }
      }
    },
    initUnselectAllRolePrivilege(grpId, roleId) {
      const selectedGrp = this.privilegeGrps.filter(grp => grp.id === grpId)
      if (selectedGrp && selectedGrp.length > 0 && this.selectedRolesPrivileges[roleId]) {
        const relevantPriv = this.getPrivilegeByGrpDeep(grpId, [])
        if (relevantPriv && relevantPriv.length > 0) {
          relevantPriv.map(priv => {
            if (this.selectedRolesPrivileges[roleId].data.includes(priv.id)) {
              this.selectedRolesPrivileges[roleId].data.splice(this.selectedRolesPrivileges[roleId].data.indexOf(priv.id), 1)
            }
          })
        }
      }
    },
    doDialogAction() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.roleForm.id === undefined) {
            // Create
            this.doAddRole()
          } else if (!this.roleForm.clone) {
            // Update
            this.doUpdateRole()
          } else {
            // Clone
            this.doCloneRole()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doAddRole() {
      const apiURI = this.menu.addRole
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.roleForm)
          const { data } = result

          if (data.data) {
            this.roles.push(data.data)

            // Show message via notify
            this.notify(data)
          }
          this.submitting = false
          this.showCreateDialog = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doUpdateRole() {
      const apiURI = this.menu.updateRole
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            id: this.roleForm.id
          }
          const result = await this.$http.patch(expandURI(apiURI, expand), this.roleForm)
          const { data } = result

          if (data.data) {
            // Update local data
            const selectedRole = this.roles.filter(role => role.value === this.roleForm.id)
            if (selectedRole.length > 0) {
              selectedRole[0].label = this.roleForm.description
            }

            // Show message via notify
            this.notify(data)
          }
          this.submitting = false
          this.showCreateDialog = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doCloneRole() {
      const apiURI = this.menu.cloneRole
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            id: this.roleForm.id
          }
          const result = await this.$http.post(expandURI(apiURI, expand), this.roleForm)
          const { data } = result

          if (data.data) {
            this.roles.push(data.data)

            // Show message via notify
            this.notify(data)
          }
          this.submitting = false
          this.showCreateDialog = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doDeleteRole() {
      const apiURI = this.menu.deleteRole
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            id: this.roleContext.selectedId
          }
          const result = await this.$http.delete(expandURI(apiURI, expand))
          const { data } = result

          if (data) {
            // Remove local data
            this.roles.splice(this.roles.indexOf(this.roles.find(role => role.value === this.roleContext.selectedId)), 1)
            // Remove from selected array also (in case they press compare and delete from context)
            this.selectedRoles.splice(this.selectedRoles.indexOf(this.selectedRoles.find(role => role.value === this.roleContext.selectedId)), 1)

            // Show message via notify
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    selectRole(id) {
      // Cannot have more than 4 in comparison
      if (this.selectedRoles.length < 4) {
        if (this.selectedRoles.filter(role => role.value === id).length === 0) {
          const selectedRole = this.roles.filter(role => role.value === id)
          if (selectedRole.length > 0) {
            // Push into selectedRole array
            this.selectedRoles.push(selectedRole[0])

            // Look for record from backend
            this.getRolePrivileges(selectedRole[0].value)
          }
        }
      } else {
        this.$snotify.warning('You have exceeded the number of records for comparison')
      }
    },
    unselectRole(id) {
      this.selectedRoles.splice(this.selectedRoles.indexOf(this.selectedRoles.find(role => role.value === id)), 1)
    },
    async getRolePrivileges(id) {
      // Remove record from selectedRolePrivileges (as we want a fresh record from back end)
      if (this.selectedRolesPrivileges[id]) {
        delete this.selectedRolesPrivileges[id]
      }
      // Insert a dummy record 1st
      this.$set(this.selectedRolesPrivileges, id, {
        loading: true,
        edit: false,
        data: []
      })
      const apiURI = this.menu.rolePrivileges
      if (apiURI) {
        try {
          const expand = {
            id: id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result

          if (data.data) {
            // Update local data
            this.selectedRolesPrivileges[id].loading = false
            this.selectedRolesPrivileges[id].data = data.data
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.notify('Invalid API URL')
      }
    },
    async doSaveRolePrivilege(id) {
      if (this.selectedRolesPrivileges[id]) {
        const apiURI = this.menu.saveRolePrivileges
        if (apiURI) {
          this.selectedRolesPrivileges[id].edit = false
          this.selectedRolesPrivileges[id].loading = true
          try {
            const expand = {
              id: id
            }
            const result = await this.$http.post(expandURI(apiURI, expand), this.selectedRolesPrivileges[id].data)
            const { data } = result
            this.notify(data)
            this.selectedRolesPrivileges[id].loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            this.selectedRolesPrivileges[id].loading = false
            this.selectedRolesPrivileges[id].edit = true
          }
        } else {
          this.notify('Invalid API URL')
        }
      } else {
        this.notify('Something went wrong. Code: 1')
      }
    },
    renderContext(e, id) {
      this.roleContext.selectedId = id
      e.preventDefault()
      this.roleContext.show = false
      this.roleContext.xAxis = e.clientX
      this.roleContext.yAxis = e.clientY
      this.$nextTick(() => {
        this.roleContext.show = true
      })
    },
    expandAll() {
      this.panel = [...this.getGroupsByLvl(0)].map(_ => true)
    },
    collapseAll() {
      this.panel = []
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.privilegeRow:hover {
  background-color: #f5f5f5;
}
.privilegeLbl {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
}
.roleHeaderDiv {
  text-align: center;
  .roleHeaderAction {
    padding-top: 5px;
    i {
      padding-left: 3px;
      padding-right: 3px;
    }
    i:hover {
      cursor: pointer;
    }
  }
}
.checkAllDiv {
  text-align: center;
  i {
    padding-left: 3px;
    padding-right: 3px;
  }
  i:hover {
    cursor: pointer;
  }
}
.editablePriv {
  // Override some styling so the check box will align center
  .v-input__slot {
    justify-content: center;
    align-content: center;
    i {
      left: auto !important;
    }
  }
}
</style>
